<template>
    <div class="flex flex-col items-center w-full border border-grey bg-white py-32 px-10  font-sans rounded-lg">
        <div class="text-additional-text text-3xl font-sans font-bold ">{{subject}}</div>
        <button class="outline-none w-48 bg-brand-light text-white font-bold font-base font-sans h-10 rounded-full mt-5"
                @click.prevent="newEvent"
        >
            Создать
        </button>
    </div>
</template>

<script>
export default {
  name: 'EventsListNone',
  props: ['subject'],
  methods: {
    newEvent() {
      this.$emit('create');
    },
  },
};
</script>
